import { DEFAULT_LIMIT } from '../assets/constants.js'
import actions from './actions.js'
import * as types from './types.js'

const state = {
  loading: false,
  availableProducts: ['ETR', 'ETP'],
  pendingSettlements: {
    ETR: [],
    ETP: []
  },
  pagination: {
    ETR: {
      page: 1,
      limit: DEFAULT_LIMIT,
      total_items: 0,
      total_pages: 0
    },
    ETP: {
      offset: 0,
      limit: DEFAULT_LIMIT,
      total_items: 0
    }
  },
  selectedProduct: 'ETR',
  selectedSettlements: []
}

const mutations = {
  [types.SET_PENDING_SETTLEMENTS_RESPONSE](state, resp) {
    state.pendingSettlements[resp.product] = resp.result
    state.pagination[resp.product] = resp.summary
  },
  [types.SET_LOADING](state, loading) {
    state.loading = loading
  },
  [types.SET_SELECTED_PRODUCT](state, product) {
    state.selectedProduct = product
  },
  [types.SET_PAGINATION](state, pagination) {
    state.pagination[state.selectedProduct] = Object.assign(
      state.pagination[state.selectedProduct],
      pagination
    )
  },
  [types.SET_SELECTED_SETTLEMENTS](state, selectedSettlements) {
    state.selectedSettlements = selectedSettlements
  }
}

export default {
  state,
  mutations,
  actions
}
